module.exports = __webpack_public_path__ + "img/icon5.c459c788.png";